import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';   
import { CategoryModel } from '@ascschool/model/category/category-model.model'; 
import { UtilsService } from '@ascschool/services/utils.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalRef } from 'ng-zorro-antd/modal';         
import { TypeOfEducationInvolveService } from '@ascschool/services/category/type-of-education-involve.service';
import { TypeOfOrganizationService } from '@ascschool/services/category/type-of-organization.service';
import { KindOfSupportService } from '@ascschool/services/category/kind-of-support.service';
import { CareerService } from '@ascschool/services/category/career.service';
import { StudyModeService } from '@ascschool/services/category/study-mode.service';
import { HinhThucHoc } from '@ascschool/model/category/hinh-thuc-hoc.model';
import { ClassService } from '@ascschool/services/category/class.service';
import { LopHoc } from '@ascschool/model/category/lop-hoc.model';
import { el } from 'date-fns/locale';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { SchoolLevelService } from '@ascschool/services/school/school-level.service';
import { ViewChild } from '@angular/core';
import { ElementRef } from '@angular/core';

@Component({
  selector: 'app-pop-up-lop-hoc',
  templateUrl: './pop-up-lop-hoc.component.html',
  styleUrls: ['./pop-up-lop-hoc.component.scss']
})
export class PopUpLopHocComponent implements OnInit {
  @Input() value: any;
  isEditMode = false;
  @ViewChild("form", { static: false }) formElement: ElementRef;
  lophoc = new LopHoc();
  errorMsg: string;
  isDisabled = false;
  validateForm!: FormGroup; 
  getSchoolLevelACFn: (value: any) => Observable<any>;
  SchoolLevelSubscription: any;
  SchoolLevelControl = new FormControl();
  constructor(
    private modal: NzModalRef,
    private msg: NzMessageService,
    private route: ActivatedRoute,
    public utilsService: UtilsService,
    private schoolLevrlService : SchoolLevelService,
    private service: ClassService,
    private fb: FormBuilder,
  ) {
  }

  ngOnInit() {
    if (this.value && this.value.id > 0) {
      this.GetById(this.value.id);
      this.isEditMode = true;
      this.lophoc.id = this.value.id; 
      this.validateForm = this.fb.group({
        id : this.value.id,
        classCode: [this.value.classCode, [Validators.required]],
        className: [this.value.className, [Validators.required]],
      });
    } else {
      this.lophoc = new LopHoc();
      this.isEditMode = false;
      this.validateForm = this.fb.group({
        classCode: [null, [Validators.required]],
        className: [null, [Validators.required]],
      });
    }
    this.loadSchoolLevel();
  }
  loadSchoolLevel() {
    // tslint:disable-next-line: max-line-length
    this.getSchoolLevelACFn = (value: any) => this.schoolLevrlService.getSchoolLevelsSelectPaging({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.schoolLevelName })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    if (!this.SchoolLevelSubscription) { this.SchoolLevelSubscription = this.SchoolLevelControl.valueChanges.subscribe(() => {
      this.utilsService.bindOrUnBindTheId(this.lophoc, 'schoolLevelId', this.SchoolLevelControl.value);
    });
    }
  }
  changeSchoolLevel(control: FormControl) {
    this.SchoolLevelControl = control;
  }
  GetById(id: number){
    this.service.getClassById(id).subscribe((res: any) => {
      
      this.lophoc = res;
    });
  }
  close() {
    this.destroyModal();
  }
  destroyModal(): void {
    this.modal.destroy(true);
  }
  UpdateClose(){
    if(this.lophoc.schoolLevelId){

      if (this.validateForm.valid){
        this.lophoc = this.validateForm.value;  
        this.service.addOrUpdateClass(this.lophoc).subscribe((res) => {
          if (res.statusCode === 0){
            this.notification(res);
            this.close();
          }else{
            this.notification(res);
          }
        }, error => {
          this.msg.error('lỗi: ' + error.error.Message);
        }
        );
      }
  else{
      this.utilsService.findInvalidControlsbyForm(this.validateForm,this.formElement);
    }
    }else{
      this.msg.warning('Vui lòng chọn cấp học');
    }
  }
  notification(response){
    if (response.statusCode === 0){
      this.msg.success('Cập nhật thông tin: ' + response.message);
    }else{
      this.msg.error('Lỗi: ' + response.message);
    }
  }
}
